
import React from 'react';
import _ from 'lodash';

import { changePeople, CHANGE_PEOPLE } from '../actions';
import translator from 'translate-react';
import { LocalString } from 'translate-react';
import { connect } from 'react-redux';


var defaultState = {
    "rooms": 1,
    "rooms.1.type": "any",
    "rooms.1.bedrooms": 0,
    "rooms.1.adults": 2,
    "rooms.1.children": 0,
    "rooms.1.child1": 10,
    "rooms.1.child2": 10,
    "rooms.1.child3": 10,
    "rooms.1.child4": 10,
    "rooms.1.child5": 10,
    "rooms.2.type": "any",
    "rooms.2.bedrooms": 0,
    "rooms.2.adults": 2,
    "rooms.2.children": 0,
    "rooms.2.child1": 10,
    "rooms.2.child2": 10,
    "rooms.2.child3": 10,
    "rooms.2.child4": 10,
    "rooms.2.child5": 10,
    "rooms.3.type": "any",
    "rooms.3.bedrooms": 0,
    "rooms.3.adults": 2,
    "rooms.3.children": 0,
    "rooms.3.child1": 10,
    "rooms.3.child2": 10,
    "rooms.3.child3": 10,
    "rooms.3.child4": 10,
    "rooms.3.child5": 10,
};


export var peopleSelectReducer = (state = defaultState, action) => {

	switch ( action.type ) {
		case CHANGE_PEOPLE:
			state = { ...state };
			state[action.key] = action.value;
			break;
	}

	return state;
};

/**
 * Ein einzelner +/- Selektor
 */
var Selector = (props) => {
	var { name, label, value, onChange, min, max, align, mode } = props;
	mode = mode || "default";

	var options = [];
	for ( let i = min; i <= max; ++i ) {
		options.push(<option value={i} key={i}>{i}</option>);
	}

	var subtract = <button
						onTouchStart={(e) => { e.preventDefault(); (value > min) && onChange(name, value - 1) }}
						disabled={!(value > min)}
						onClick={e => { e.preventDefault(); onChange(name, value - 1)} }>
						-
					</button>;
	var add      = <button
						onTouchStart={(e) => { e.preventDefault(); (value < max) && onChange(name, value + 1) }}
						disabled={!(value < max)}
						onClick={e => { e.preventDefault(); onChange(name, value + 1)} }>
						+
					</button>;
	var selector = (
		<select min={min} max={max} value={value} onChange={(e) => onChange(name, parseInt(e.currentTarget.value, 10))}>
			{options}
		</select>
	);

	switch ( mode ) {
	case "default":
		return (
			<div className="people-selector">
				{subtract}{selector}{add}
				<label>{label}</label>
			</div>
		);

	case "child":
		return (
			<div className="people-selectorchild">
				<label className="childnum">{label}</label>
				{subtract}{selector}{add}
				<label className="childs"><LocalString word={"Jahre"} /></label>
			</div>
		);

	default:
		throw new Error("Selector Component: Unknown mode: " + mode);
	}

}

export var PeopleSelect = function(props, context) {
	let { state, room, onChange } = props;

	let maxRooms = props.maxRooms || 3;
	let maxAdultsPerRoom = typeof props.maxAdultsPerRoom !== "undefined" ? props.maxAdultsPerRoom : 15;
	let maxChildrenPerRoom = typeof props.maxChildrenPerRoom !== "undefined" ? props.maxChildrenPerRoom : 5;

	let strRoomCount = translator.get("Anzahl Zimmer");
	let strAdultCount = maxChildrenPerRoom > 0 ? translator.get("Anzahl Erwachsene") : translator.get("Personen");
	let strChildCount = translator.get("Anzahl Kinder");
	let strChild = translator.get("Kind") + " ";

	var elements = [];
	if ( !room ) {
		elements.push(<Selector key="rooms" name="rooms" label={strRoomCount} value={state.rooms} min="1" max={maxRooms} onChange={onChange} />);
	}

	_.times(room ? 1 : state.rooms, function(i) {
		i++;
		i = room ? room : i;

		let key = "rooms." + i + ".adults";
		if ( !room ) {
			elements.push(<hr key={"spacer-" + i} />);
			elements.push(<div className="subtitle" key={"subtitle-" + i}>Belegung Unterkunft {i}</div>);
		}
		elements.push(
			<Selector key={key} name={key} label={strAdultCount} value={state[key]} min="1" max={maxAdultsPerRoom} onChange={onChange} />
		);

		key = "rooms." + i + ".children";
		let num_children = state[key];

		if ( maxChildrenPerRoom > 0 ) {
			elements.push(
				<Selector key={key} name={key} label={strChildCount} value={state[key]} min="0" max={maxChildrenPerRoom} onChange={onChange} />
			);
		}

		if ( num_children > 0 ) {
			let children = _.times(num_children, function(j) {
				j++;
				let key = "rooms." + i + ".child" + j;
				return (
					<Selector key={key} name={key} label={strChild + j + ":"} value={state[key]} min="1" max="17" onChange={onChange} mode="child" />
				);
			});

			elements.push(
				<div className="child-group" key={"childgroup-" + i}>
					<div className="subtitle"><LocalString word={"Alter bei Reiseantritt"} /></div>
					{children}
				</div>
			);

		}
	});

	return (
		<div className="people-select">
			{elements}
		</div>
	);
};


const mapStateToProps = (state) => ({
	state: state.people
})

const mapDispatchToProps = (dispatch) => ({
	onChange: (name, value) => dispatch(changePeople(name, value)),
})

export default connect(mapStateToProps, mapDispatchToProps)(PeopleSelect);



/** WEBPACK FOOTER **
 ** ../ibe/components/PeopleSelect.js
 **/